import { AppElement, AppFC } from '../../../interfaces';

export const MinusIcon: AppFC = (): AppElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="2" viewBox="0 0 14 2" fill="none">
    <path d="M13 1H1" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
